import React from "react";
import './Service.css'

function ServiceHeader(){
     return(
          <div className="services">
                <h5 className="h5">Our  sevices</h5>
                 <p className="pap">we offer quality and affordable health services to your pets</p>
    
          </div>
  
     )
}
export default ServiceHeader;